// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status--PctJe {\n  color: orange;\n  border-color: orange;\n}", "",{"version":3,"sources":["webpack://./src/gui/Components/Status/AwaitingResponses/index.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;AACtB","sourcesContent":[".status {\n  color: orange;\n  border-color: orange;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": "status--PctJe"
};
export default ___CSS_LOADER_EXPORT___;
